import { Button, TextField, MenuItem, Select, InputLabel, FormControl } from '@mui/material';
import React, { useState, useEffect, useRef } from 'react';
import CustTable from '../comp/custtable/custtable';
import RefreshIcon from '@mui/icons-material/Refresh';
import DiscountAdd from './discountadd';
import DiscountMod from './discountmod';

const Discounts = ({ token }) => {
    const [items, setItems] = useState([]);
    const [[start, end], setSEnd] = useState([0, 20])
    const [sstr, setSearch] = useState("");
    const [allcont, setAllCount] = useState(0);
    const [loading, setLoad] = useState(true);
    const [addmodal, setAddModal] = useState(false);
    const [modmodal, setModModal] = useState(false);
    const [custrow, setcustrow] = useState([]);
    
    

    const searchRef = useRef();

    const columns = [
        { field: 'id', headerName: 'Дугаар', },
        { field: 'dis_type', headerName: 'Хямдрал төрөл', width: 200 },
        { field: 'dis_prod_code', headerName: 'Хямдрал барааны код', width: 200 },
        { field: 'dis_prod_name', headerName: 'Барааны нэр', width: 200 },
        { field: 'dis_brand_id', headerName: 'Хямдрал брэнд код', width: 200 },
        { field: 'dis_brand_name', headerName: 'Хямдрал брэнд код', width: 200 },
        { field: 'discount_prcnt', headerName: 'Хямдрал хувь', width: 200 },
        { field: 'dis_threashold', headerName: 'Хямдрал хязгаар', width: 200 },
        { field: 'cre_date', headerName: 'Үүсгэсэн огноо', width: 200 },
        { field: 'cre_emp_id', headerName: 'Үүсгэсэн ажилтан', width: 200 },
        
    ];

    const rowClick = (e) => {

        setcustrow(e);
        setModModal(true);

    }

    useEffect(() => {
        var url = 'https://wms-cloud.com/api/DiscountProduct?_start='+start+'&_end='+end;
        //var url = 'http://localhost:8080/Brand?_start='+start+'&_end='+end;
        if(sstr!="")
        {
            url=url+'&search=' + sstr;
        }
        const request = new Request(url, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'Access-Control-Allow-Headers': 'X-Total-Count'
            })
        });
        fetch(request).then(
            (response) => {
                if (response.status == 200) {
                    console.log(response.headers.get('X-Total-Count'));
                    setAllCount(response.headers.get('X-Total-Count'));
                    return response.json();
                } else if (response.status == 500) {
                    alert("Алдаа гарлаа дахин оролдоно уу.");
                } else {
                    localStorage.removeItem('tok');
                    window.location.reload(false);
                    alert("Алдаа гарлаа.")
                }
            }
        ).then((resp) => {
            setItems(resp);
            setLoad(false);
        });

    }, [start, end, sstr])

    const handlePage = (e) => {
        console.log('aaaa: '+e);
        setLoad(true);
        setSEnd([e * 20, (e * 20) + 20]);
    }


    const searchTextChange = (e) =>{
        if (e.keyCode == 13) {
        setSearch(searchRef.current.value);
        }
    }
    const custRefresh = () => {
        window.location.reload(false);
    }



    return <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
        <div className="parenthead">
            <div>
                <h3>Барааны хямдралын тохиргоо
                </h3>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <TextField inputRef={searchRef} size="small" label="Нэрээр хайх" onKeyDown={searchTextChange} />
                <Button style={{ height: "40px" }} variant="outlined" onClick={setAddModal} >Хямдрал үүсгэх</Button>
                <Button variant="outlined" style={{ height: "40px" }} onClick={() => {
                    window.location.reload(false);
                }}> <RefreshIcon /> </Button>
            </div>
        </div>
        <div className="tablecont">
            <CustTable
                name={"Discount Product"}
                columns={columns}
                items={items}
                allcont={allcont}
                handlePage={handlePage}
                rowClick={rowClick}
                loading={loading} />
        </div>
        {addmodal ?
        <DiscountAdd handleClose={setAddModal}
        token={token}
        open={addmodal}
        handleRefresh={custRefresh}
        handleModal={setAddModal} /> : <></>
        }
        {modmodal ?
        <DiscountMod handleClose={setModModal}
        token={token}
        open={modmodal}
        custrow={custrow}
        handleRefresh={custRefresh}
        handleModal={setModModal} /> : <></>
        }
    </div>

}

export default Discounts;